/**
 * Pure helpers for /whitelist-login: try app deep link, then web fallback.
 */

export const APP_OPEN_WAIT_MS = 1800;

export function normalizeWhitelistToken(rawToken) {
  if (rawToken == null || rawToken === "") return null;
  return String(rawToken).replace(/ /g, "+");
}

export function buildAppWhitelistDeepLink(token) {
  if (!token) return null;
  return `pawprint://whitelist-login?token=${encodeURIComponent(token)}`;
}

/** Only attempt custom-scheme open on typical mobile browsers. */
export function shouldAttemptAppDeepLink(userAgent = "") {
  return /iPhone|iPad|iPod|Android/i.test(String(userAgent || ""));
}

export function isIosUserAgent(userAgent = "") {
  return /iPhone|iPad|iPod/i.test(String(userAgent || ""));
}

/**
 * After attempting a deep link, decide whether to run web consume.
 * If the page was hidden during the wait, assume the app opened.
 */
export function shouldFallbackToWeb({ pageWasHidden }) {
  return !pageWasHidden;
}
